import React from 'react'

function Endorse(){

    return(
        <section className="endorse" style={{backgroundColor:"White",paddingBottom:"60px"}}>
        <h1>Endorsed By</h1>
        <div >  
            <img src="images/usa.jpg" alt="United State" />

            <img src="images/use.jpg" alt="United State Embassy" /> 
        </div>
       </section>
    )
}

export default Endorse